export default __webpack_public_path__ + "static/media/fi-rr-angle-small-right-59595B.21a70f9e.svg";